import http from '../../../Utils/http';
const ProfileUpdate = {
  name: 'profileUpdate',
  state: {
    profileLoading: false,
    error: '',
    permissions: [
      'organization:view',
      'organization:create',
      'organization:delete',
      'organization:update',
    ],
    userInformation: {},
    profileMessage: '',
    active: '',
    userData: {},
  },
  reducers: {
    profileUpdateRequested(state) {
      return {
        ...state,
        profileLoading: true,
        error: '',
        profileMessage: '',
      };
    },
    profileUpdateReceived(state, payload) {
      return {
        ...state,
        profileLoading: false,
        profileMessage: 'Changes have been saved.',
        error: '',
      }
    },
    profileUpdateRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
        profileMessage: '',
        profileLoading: false,
      };
    },

    profileDetailsRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        message: '',
        active: '',
      };
    },
    profileDetailsReceived(state, payload) {
      return {
        ...state,
        loading: false,
        userInformation: payload,
        error: '',
      }
    },
    profileDetailReceived(state, payload) {
      return {
        ...state,
        active: payload?.active,
        error: '',
      }
    },
    userProfileDetailsReceived(state, payload) {
      return {
        ...state,
        userData: payload,
        error: '',
      }
    },
    profileDetailsFailed(state, payload) {
      return {
        ...state,
        error: payload,
        userInfo: {},
        loading: false,
      };
    },

  },
  effects: (dispatch) => ({
    async requestForProfileUpdate(data) {
      try {
        this.profileUpdateRequested();
        const { id, name, email, file } = data;
        const user_id = JSON.parse(localStorage.getItem('userInfo')).id;
        const formData = new FormData();
        formData.append('name', name || '');
        formData.append('email', email || '');
        if (file instanceof File) {
          formData.append('file', file);
        }
        const response = await http.put(`savvy/users/${id}?user_id=${user_id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
        );
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        if (userInfo?.organization.type === 'ADV')
          await dispatch.ProgressStepAdv.UpdateGetADVProgressStep(2);
        if (userInfo?.organization.type === 'DSO')
          await dispatch.ProgressStepDSO.UpdateGetDSOProgressStep(5);

        this.profileUpdateReceived(response.data.message);
      } catch (err) {
        const errorMessage = err.response?.data?.error || err.message || 'Failed to update profile';
        this.profileUpdateRequestFailed(errorMessage);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Invalid Credentials',
            open: true,
          },
        });
      }
    },
    async requestForProfileData(data) {
      try {
        this.profileDetailsRequested();
        const { id } = data;
        const response = await http.get(`savvy/users/getUserDetails/${id}`, data);
        const storedUserInfo = JSON.parse(localStorage.getItem('userInfo'));
        if (response && response.data && response.data.userInfo) {
          storedUserInfo.isProfileCompleted = response.data.userInfo.isProfileCompleted;
          localStorage.setItem('userInfo', JSON.stringify(storedUserInfo));
          this.profileDetailsReceived(response.data.userInfo);
        }
      } catch (err) {
        const errorMessage = err.response?.data?.error || err.message || 'Failed to fetch profile data';
        this.profileDetailsFailed(errorMessage);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Invalid Credentials',
            open: true,
          },
        });
      }
    },
    async getById(id) {
      try {
        this.profileDetailsRequested();
        const response = await http.get(`savvy/users/getUserDetails/${id}`);
        this.profileDetailReceived(response.data.data);
      } catch (err) {
        const errorMessage = err.response?.data?.error || err.message || 'Failed to fetch profile details';
        this.profileDetailsFailed(errorMessage);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Invalid Credentials',
            open: true,
          },
        });
        dispatch.profileUpdate.clearProfileMessage();
      }
    },

    async getUserByOrgId(id) {
      try {
        this.profileDetailsRequested();
        const response = await http.get(`savvy/users/getUserDetailsByOrg/${id}`);
        this.userProfileDetailsReceived(response.data.userInfo);
      } catch (err) {
        const errorMessage = err.response?.data?.error || err.message || 'Failed to fetch user profile';
        this.profileDetailsFailed(errorMessage);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Invalid Credentials',
            open: true,
          },
        });
        // dispatch.profileUpdate.clearProfileMessage();
      }
    },
    async updateStatus({ id, active }) {
      try {
        this.profileDetailsRequested();
        let url;
        const Id = id;
        if (active === 'deactivate') {
          url = `savvy/users/deactivate/${Id}`;
        } else {
          url = `savvy/users/activate/${Id}`;
        }
        await http.put(url);
        await this.getById(id);
      } catch (err) {
        const errorMessage = err.response?.data?.error || err.message || 'Failed to update status';
        this.profileDetailsFailed(errorMessage);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Invalid Credentials',
            open: true,
          },
        });
        dispatch.profileUpdate.clearProfileMessage();
      }
    },
    async clearData() {
      this.profileUpdateReceived('');
      this.profileUpdateRequestFailed('');
    },
  }),
};

export default ProfileUpdate;